import { render } from "./PawPrint.svg?vue&type=template&id=c9dafeb8"
const script = {}
script.render = render

export default script